import { createSlice } from "@reduxjs/toolkit";
import { postRequest } from "../../services/apiCaller/cl_index";
import { endpoints } from "../../api/ApiEndPoints";
import { getFromLocalStorage } from "../../services/helper/cl_Helper";

const initialState = {
    myBetsData: "",
}

const token = getFromLocalStorage("gk");

export const myBetsSlice = createSlice({
    name: "mybets",
    initialState,
    reducers:{
        setMyBetsData: (state, action) => {
            state.myBetsData = action.payload;
        }
    }
});

export const {setMyBetsData} = myBetsSlice.actions;

export default myBetsSlice.reducer;

export const fetchMyBets = () => (dispatch) => {
    let url = `${endpoints.betHistory}?X-Client-Id=${token}`;
    const payload = {
        accessToken: token,
        channel: "Internet",
        ticketStatus: "Open"
    };
    postRequest(url, payload).then((res) => {
        console.log("res: ", res);
        if (res?.status === 200) {
          dispatch(setMyBetsData(res.data));
        }
      });
}